module.exports = __webpack_public_path__ + "static/media/leaf_structure.c808616c.png";